export default __webpack_public_path__ + "static/media/SPIT_logo.a0c056b7.png";